import { actionCopyEs } from "./actionCopy";
import { listCopyEs } from "./listCopy";

export const templatesCopyEs = {
    templates: "Modelos",
    navDescription: "Consulte los modelos e invite a los pacientes a hacer el seguimiento de sus resultados.",
    myTemplatesTitle: "Mis modelos",
    myTemplatesDescription:
        "Cree y gestione modelos para invitar rápidamente a los pacientes a hacer el seguimiento de sus resultados. Haga clic en una fila para usar un modelo, o abra el menú para otras acciones.",
    myTemplatesAria: "Mis modelos",
    publicTemplatesTitle: "Modelos públicos",
    breadcrumbNew: "Nuevo",
    selectAtLeastOneTemplate: "Seleccione al menos un modelo",
    addTemplatesToAccount: (count) =>
        count === 1 ? "Añadir el modelo a mi cuenta" : `Añadir ${count} modelos a mi cuenta`,
    creatingTemplates: "Creando los modelos…",
    publicTemplatesDescription:
        "Consulte configuraciones listas para usar y añádalas a su cuenta, o cree las suyas. Seleccione un modelo para empezar rápidamente.",
    browsePublic: "Consultar los modelos públicos",
    browsePublicAria: "Consultar los modelos públicos",
    newTemplate: "Nuevo modelo",
    newTemplateAria: "Nuevo modelo",
    makeMyOwn: "Crear el mío",
    favourites: "Favoritos",
    noQuestionnaires: "Ningún cuestionario",
    moreQuestionnaires: (count) => `+${count} más`,
    useTemplate: "Usar el modelo",
    newDiary: "Nuevo diario",
    searchPlaceholder: "Buscar modelos...",
    searchAria: "Buscar modelos",
    clearSearchAria: actionCopyEs.clearSearch,
    filters: actionCopyEs.filters,
    clearAll: actionCopyEs.clearAll,
    procedureFilterPrefix: "Intervención:",
    statusFilterPrefix: "Estado:",
    substanceFilterPrefix: "Sustancia:",
    subsiteFilterPrefix: "Sublocalización:",
    siteFilterPrefix: "Localización:",
    typeFilterPrefix: "Tipo:",
    areaFilterPrefix: "Área:",
    consultationFilterPrefix: "Consulta:",
    removeProcedureFilterAria: (label) => `Quitar el filtro de intervención ${label}`,
    removeStatusFilterAria: (label) => `Quitar el filtro de estado ${label}`,
    removeOwnerFilterAria: (name) => `Quitar el filtro del propietario ${name}`,
    removePeopleFilterAria: (name) => `Quitar el filtro de las personas ${name}`,
    removeSubstanceFilterAria: "Quitar el filtro de la sustancia",
    removeSubsiteFilterAria: "Quitar el filtro de la sublocalización",
    removeSiteFilterAria: "Quitar el filtro de la localización",
    removeShockwaveTypeFilterAria: "Quitar el filtro del tipo de ondas de choque",
    removeAreaFilterAria: "Quitar el filtro del área",
    removeConsultationFilterAria: "Quitar el filtro de la consulta",
    ownerFilterLabel: "Propietario (clínico o secretario)",
    ownerFilterPlaceholder: "Todos los usuarios",
    statusFilterLabel: "Estado",
    statusFilterPlaceholder: "Todos los estados",
    peopleOnTemplateLabel: "Personas en el modelo",
    peopleOnTemplatePlaceholder: "Cualquier persona en el modelo",
    procedureTypeLabel: "Tipo de intervención",
    procedureTypePlaceholder: "Cualquier tipo de intervención",
    areaLabel: "Área",
    substanceLabel: "Sustancia",
    subsiteLabel: "Sublocalización",
    typeLabel: "Tipo",
    siteLabel: "Localización",
    consultationLabel: "Consulta",
    selectPlaceholder: "Seleccionar...",
    clearFilterAria: (label) => `Borrar ${label}`,
    injection: "Inyección",
    shockwave: "Ondas de choque",
    surgery: "Cirugía",
    consultation: "Consulta",
    medication: "Medicamento",
    product: "Producto",
    published: listCopyEs.published,
    draft: listCopyEs.draft,
    noTemplatesYet: "Ningún modelo por el momento",
    noMatchingTemplates: "Ningún modelo coincidente",
    noTemplatesYetHint: "Cree su primer modelo para invitar rápidamente a los pacientes.",
    noMatchingHint: "Pruebe a modificar la búsqueda o los filtros.",
    createFirstTemplate: "Crear su primer modelo",
    emptyTemplatesHelpLink: "¿Cómo crear un modelo?",
    tableHint:
        "Haga clic en una fila para invitar a un paciente desde este modelo. Use « Nuevo diario » y Modificar en cada fila, o abra el menú para los favoritos y otras acciones.",
    forms: "Formularios",
    lastEdited: "Última modificación",
    procedure: "Intervención",
    area: "Área",
    people: "Personas",
    details: "Detalles",
    actions: listCopyEs.actions,
    select: "Seleccionar",
    useTemplateAria: "Nuevo diario",
    editTemplateAria: "Modificar el modelo",
    tapToUseTemplate: "Pulse para usar este modelo",
    useThisTemplateAria: "Usar este modelo",
    clickRowToUseAria: "Haga clic en la fila para usar este modelo",
    publicTemplatesTableAria: "Modelos públicos",
    yourTemplatesTableAria: "Sus modelos; elija una fila para usar este modelo, o use las acciones de cada fila",
    noTemplatesInView: "Ningún modelo en esta vista.",
    showingTemplatesRange: (start, end, total) => `Modelos del ${start} al ${end} de ${total}`,
    previous: actionCopyEs.previous,
    next: actionCopyEs.next,
    save: actionCopyEs.save,
    rename: actionCopyEs.rename,
    editTemplate: "Modificar el modelo",
    addToFavourites: "Añadir a favoritos",
    removeFromFavourites: "Quitar de favoritos",
    copyUrl: "Copiar la URL",
    shareTemplate: "Compartir el modelo",
    labelsAndDiaryType: "Etiquetas y tipo de diario",
    publishTemplate: "Publicar el modelo",
    duplicate: actionCopyEs.duplicate,
    delete: actionCopyEs.delete,
    deleteTemplateTitle: "Eliminar el modelo",
    deleteTemplateDescription: "¿Desea realmente eliminar este modelo? Esta acción es irreversible.",
    cancel: actionCopyEs.cancel,
    templateUpdatedToast: "Modelo actualizado correctamente",
    copiedToClipboardToast: "Copiado en el portapapeles",
    unnamedTemplate: "Modelo sin nombre",
    questionnaireSchedule: "Calendario del cuestionario",
    interventionStep: "Intervención",
    injectionDetails: "Información sobre la inyección",
    surgeryClinicians: "Clínicos de la cirugía",
    surgeryDetails: "Información sobre la cirugía",
    shockwaveClinicians: "Clínicos de las ondas de choque",
    shockwaveDetails: "Información sobre las ondas de choque",
    noIntervention: "Ninguna intervención",
    dateStep: "Fecha",
    dateQuestion: "¿Desde qué fecha se cuentan los seguimientos?",
    dateDiaryStart: "Desde el día en que se crea el diario",
    dateDiaryStartHint: "Los cuestionarios empiezan enseguida. No se pide una fecha al paciente.",
    dateAskPatient: "Dejar en blanco - nos la indica el paciente",
    dateAskPatientHint: "El paciente indica la fecha al configurar su diario. También puede añadirla más tarde.",
    saveTemplate: "Guardar el modelo",
    lockLabel: "Bloquear",
    unlockLabel: "Desbloquear",
    lockedLabel: "Bloqueado",
    lockScope: {
        trackers: "Cuestionarios",
        "tracker.schedule": "Calendarios",
        consents: "Consentimientos",
        event: "Intervención",
        "person.injectingClinicianId": "Clínico que realiza la inyección",
        "person.referringClinicianId": "Médico derivante",
        "person.operatingClinicianId": "Clínico que realiza la cirugía",
        "person.productId": "Producto",
    },
    lockedByTemplateCreator: "Bloqueado por el creador del modelo",
    usageInstructionsPlaceholder: "p. ej. Llevar 2 horas al día, limpiar después de cada uso",
    productNameRequired: "El nombre del producto es obligatorio",
    contactEmail: "Correo electrónico de contacto",
    contactPersonDescription:
        "Una persona con la que el paciente puede contactar si desea un contacto adicional con la clínica. Este correo electrónico se compartirá con el paciente.",
    selectContactPlaceholder: "Seleccionar un correo electrónico de contacto",
    defaultContactForOrganisation: (organisationNames) => `Predeterminado para ${organisationNames}`,
    templateCreatedTitle: "Modelo creado correctamente.",
    templateCreatedMessage: "El tiempo ahorrado es tiempo ganado.",
    templateNotFoundTitle: "Modelo no encontrado",
    templateNotFoundDescription: "No se ha podido encontrar el modelo. Inténtelo de nuevo.",
    backToTemplates: "Volver a los modelos",
    userFallback: (idPrefix) => `Usuario ${idPrefix}...`,
    eventTypeLabel: (type: string) => {
        const map: Record<string, string> = {
            injection: "Inyección",
            shockwave: "Ondas de choque",
            surgery: "Cirugía",
            education: "Consulta",
            medication: "Medicamento",
            product: "Producto",
        };
        return map[type] ?? type;
    },
    statusLabel: (status) => (status === "published" ? "Publicado" : "Borrador"),
};
